import { createRouter } from "@tanstack/react-router";
import type { AuthState } from "./auth/AuthProvider";
import { routeTree } from "./routeTree.gen";

export function createAppRouter() {
  return createRouter({
    routeTree,
    // The real auth value is injected per-render by main.tsx via
    // <RouterProvider context={{ auth }} />.
    context: { auth: undefined as unknown as AuthState },
    defaultPreload: "intent",
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
